import { mapGetters, mapMutations } from 'vuex'

export const blockPlwMixin = {
  computed: {
    ...mapGetters('presentlevels', ['developPLWPermissions', 'blurPLWPermissions'])
  },
  methods: {
    ...mapMutations('presentlevels', ['setShowBlocker', 'setBlockerPermissions']),
    shouldBlockPLW() {
      if (this.developPLWPermissions.block) {
        this.setBlockerPermissions(this.developPLWPermissions)
        this.setShowBlocker(true)
        return true
      }
      return false
    }
  }
}
